module.exports = __webpack_public_path__ + "img/wybl.8a88e986.png";